import React from "react";
import { Box, Modal, Button, Divider, Typography } from "@mui/material";
import { esignIcons } from "../Esign/icons";


const CommonDeleteModal = (props) => {
  const { title, text, open, onClose, onConfirm } = props;

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 430,
          height: 360,
          bgcolor: "#fff",
          boxShadow: 24,
          borderRadius: "20px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            p: "15px 30px",
            flexShrink: 0,
          }}
        >
          <Typography
            variant="h6"
            sx={{ fontSize: "20px", fontWeight: 600, color: "#1D1D1D" }}
          >
            {title || "Delete"}
          </Typography>
        </Box>
        <Divider />

        {/* Main content */}
        <Box
          sx={{
            flex: 1,
            p: "15px 30px",
            overflowY: "auto",
            display: "flex",
            alignItems: "start",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <Box mb={2}>{esignIcons.deleteIconWorkflow}</Box>
          <Typography fontSize={"20px"} fontWeight={400} color={"#1D1D1D"}>
            {text || "Are you sure you want to delete?"}
          </Typography>
        </Box>

        {/* Footer */}
        <Box
          sx={{
            p: "15px 30px",
            display: "flex",
            justifyContent: "space-between",
            flexShrink: 0,
          }}
        >
          <Button
            variant="contained"
            onClick={onClose}
            sx={{
              width: 170,
              height: 42,
              color: "#1D1D1D",
              background: "transparent",
              textTransform: "none",
              fontSize: "16px",
              borderRadius: "10px",
              border: "1px solid #D2D2D2",
              boxShadow: "none",
              fontWeight: "500",
            }}
          >
            No
          </Button>
          <Button
            onClick={onConfirm}
            variant="contained"
            sx={{
              width: 170,
              height: 42,
              borderRadius: 2,
              fontWeight: 500,
              fontSize: 16,
              bgcolor: "#EA464A",
              textTransform: "none",
            }}
          >
            Yes
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default CommonDeleteModal;
